export default __webpack_public_path__ + "media/images/we-present-logo-206b736c.svg";